module.exports = __webpack_public_path__ + "img/icon_business_blue.cfb5f7d7.svg";